import styled from 'styled-components'

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  margin-left: 5px;
  padding-top: 5px;
  padding-left: 10px;
  border-radius: 5px;
  margin-bottom: 5px;
  
`
